import { useState, useEffect } from "react";

export const useShowDefaultEditor = (editing: boolean, value: string) => {
  const [showDefaultEditor, setShowDefaultEditor] = useState(false);
  const valueIsNotEmpty = value.length > 0;

  useEffect(() => {
    if (!editing) {
      setShowDefaultEditor(valueIsNotEmpty);
    }
  }, [editing, valueIsNotEmpty]);

  return [
    valueIsNotEmpty || showDefaultEditor,
    () => setShowDefaultEditor(true),
  ] as const;
};
